import { DateHelper } from "../../utilities/contracts/date-helper";
import { AlertItemSupplemental } from "./alert-item-supplemental.model";

export class AlertNotification {
  readonly alertId: number;
  readonly alertTypeId: number;
  readonly message: string;
  readonly createdDate: string;
  readonly objectType: string;
  readonly objectId: number;
  readonly loggedInUserId: number;
  readonly timeStamp: string;
  readonly alertURL: string;
  readonly recordCount?: number;
  readonly supplemental?: AlertItemSupplemental;

  constructor(options: {
    alertId: number;
    alertTypeId: number;
    message: string;
    createdDate: string;
    objectType: string;
    objectId: number;
    loggedInUserId: number;
    timeStamp: string;
    alertURL: string;
    recordCount?: number;
    supplemental?: AlertItemSupplemental;
  }) {
    this.alertId = options.alertId;
    this.alertTypeId = options.alertTypeId;
    this.message = options.message;
    this.createdDate = options.createdDate;
    this.objectType = options.objectType;
    this.objectId = options.objectId;
    this.loggedInUserId = options.loggedInUserId;
    this.timeStamp = DateHelper.format(options.timeStamp, "MM/DD/YYYY");
    this.alertURL = options.alertURL;
    this.recordCount = options.recordCount;
    this.supplemental = options.supplemental;
  }
}
